
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help/articles/[id]",
      function () {
        return require("private-next-pages/help/articles/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help/articles/[id]"])
      });
    }
  